/** Query param para criar um negócio para um novo lead inserido */
export const QUERY_PARAM_LEAD_NEGOCIO = 'leadNegocio';
